import { useEffect } from 'react';
import { Button, Row } from 'react-bootstrap';
import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// hooks
import { useRedux } from '../../hooks/';

// actions
import { resetAuth, loginUser } from '../../redux/actions';

// components
import Loader from '../../components/Loader';

import AuthLayout from './AuthLayout';

type LocationState = {
    from?: Location;
};

/* bottom links */
const BottomLink = () => {

    return (
        <Row className="mt-3">
            {/* <Col xs={12} className="text-center">
                <p className="text-muted">
                    <Link to="/auth/forget-password" className="text-muted ms-1">
                        <i className="fa fa-lock me-1"></i>
                        {t('Forgot your password?')}
                    </Link>
                </p>
                <p className="text-muted">
                    {t("Don't have an account?")}{' '}
                    <Link to={'/auth/register'} className="text-dark ms-1">
                        <b>{t('Sign Up')}</b>
                    </Link>
                </p>
            </Col> */}
        </Row>
    );
};

const Login = () => {
    const { t } = useTranslation();
    const { dispatch, appSelector } = useRedux();

    const { user, userLoggedIn, loading } = appSelector((state) => ({
        user: state.Auth.user,
        loading: state.Auth.loading,
        userLoggedIn: state.Auth.userLoggedIn,
    }));

    useEffect(() => {
        dispatch(resetAuth());
    }, [dispatch]);

    /*
    handle form submission
    */
    const onSubmit = () => {
        dispatch(loginUser());
    };

    const location = useLocation();
    let redirectUrl = '/';

    if (location.state) {
        const { from } = location.state as LocationState;
        redirectUrl = from ? from.pathname : '/';
    }

    return (
        <>
            {userLoggedIn && user && <Navigate to={redirectUrl} replace />}

            <AuthLayout bottomLinks={<BottomLink />}>
                <div className="text-center mb-4">
                    <h4 className="text-uppercase mt-0">{t('Organization Sign In')}</h4>
                </div>


                {loading && <Loader />}


                <div className="text-center d-grid mb-3">
                    <Button variant="dark" className='btn-outline-light' disabled={loading} onClick={onSubmit}>
                        <i className="ti-microsoft-alt px-2"></i>
                        {t('Authenticate')}
                    </Button>
                </div>
            </AuthLayout>
        </>
    );
};

export default Login;
